import request from '@/utils/request';

/**
 * 本文件由code-generator根据yapi文档自动生成
 */

export type IuserInfoListLikeNameMobileResdataInterFace = {
  createTime: string;

  deleted: boolean;

  id: number;

  mobile: string;

  name: string;

  realName: string;

  updateTime: string;

  userStatus: number;

  uuid: string;

  xagAccountGuid: string;
};

export type IuserInfoListInvolveMarkTeamMemberResdataInterFace = {
  exist: boolean; // 如果当前用户已存在于指定的团队中，则为 true

  id: number;

  mobile: string;

  name: string;

  userStatus: number;

  uuid: string;
};

export type IuserInfoListInvolveDatasetDataUserResdataInterFace = {
  exist: boolean; // 如果当前用户已加入数据集版本下，则为true,

  id: number;

  mobile: string;

  name: string;

  userStatus: number;

  userStatusDesc: string;

  uuid: string;
};

export type IuserInfoListInvolveApplicationAuthUserResdataInterFace = {
  exist: boolean;

  id: number;

  mobile: string;

  name: string;

  userStatus: number;

  uuid: string;
};

export type IchannelGetUserChannelByTokenResdataInterFace = {
  channelId: number;

  channelName: string;

  tenantId: string;

  tenantName: string;

  thumbnail: string;
};

/**
 * 获取当前登录用户的个人信息
 */

export type userInfoGetRes = {
  data: {
    id?: number;

    mobile?: string;

    name?: string;

    realName?: string;
    avatar: string;

    uuid?: string;

    xagAccountGuid?: string;
  };

  message?: string;

  status?: number; // 响应码，200正常，其他异常
};

export function userInfoGet(): Promise<userInfoGetRes> {
  return request.get('/base/userInfo/get');
}

/**
 * 根据关键字模糊查询用户列表
 */

export type userInfoListLikeNameMobileRes = {
  data?: IuserInfoListLikeNameMobileResdataInterFace[];

  message?: string;

  status?: number;
};

export function userInfoListLikeNameMobile(): Promise<userInfoListLikeNameMobileRes> {
  return request.get('/base/userInfo/listLikeNameMobile');
}

/**
 * 获取待添加到团队的成员列表
 */

export type userInfoListInvolveMarkTeamMemberRes = {
  data?: IuserInfoListInvolveMarkTeamMemberResdataInterFace[];

  message?: string;

  status?: number;
};

export type userInfoListInvolveMarkTeamMemberReq = {
  markTeamId?: string;

  key?: string; // 用户名称或手机号模糊查询
};

export function userInfoListInvolveMarkTeamMember(
  data: userInfoListInvolveMarkTeamMemberReq
): Promise<userInfoListInvolveMarkTeamMemberRes> {
  return request.get('/base/userInfo/listInvolveMarkTeamMember', {
    params: data,
  });
}

/**
 * 获取待添加到数据集版本协助人的用户列表
 */

export type userInfoListInvolveDatasetDataUserRes = {
  data?: IuserInfoListInvolveDatasetDataUserResdataInterFace[];

  message?: string;

  status?: number;
};

export type userInfoListInvolveDatasetDataUserReq = {
  datasetVersionId: string; // 数据集版本ID

  key: string; // 手机或用户名称模糊查询
};

export function userInfoListInvolveDatasetDataUser(
  data: userInfoListInvolveDatasetDataUserReq
): Promise<userInfoListInvolveDatasetDataUserRes> {
  return request.get('/base/userInfo/listInvolveDatasetDataUser', {
    params: data,
  });
}

/**
 * 获取待添加的应用授权人列表
 */

export type userInfoListInvolveApplicationAuthUserRes = {
  data?: IuserInfoListInvolveApplicationAuthUserResdataInterFace[];

  message?: string;

  status?: number;
};

export type userInfoListInvolveApplicationAuthUserReq = {
  key: string;

  applicationId: string;
};

export function userInfoListInvolveApplicationAuthUser(
  data: userInfoListInvolveApplicationAuthUserReq
): Promise<userInfoListInvolveApplicationAuthUserRes> {
  return request.get('/base/userInfo/listInvolveApplicationAuthUser', {
    params: data,
  });
}

/**
 * 获取待添加的推理任务协助人列表
 */

export type userInfoListInvolveInferAssistUserRes = any;

export type userInfoListInvolveInferAssistUserReq = {
  key?: string;

  inferTaskId: string;
};

export function userInfoListInvolveInferAssistUser(
  data: userInfoListInvolveInferAssistUserReq
): Promise<userInfoListInvolveInferAssistUserRes> {
  return request.get('/base/userInfo/listInvolveInferAssistUser', {
    params: data,
  });
}

/**
 * 查询登录用户的渠道列表
 */

export type channelGetUserChannelByTokenRes = {
  data?: IchannelGetUserChannelByTokenResdataInterFace[];

  message?: string;

  status?: number;
};

export type channelGetUserChannelByTokenReq = {
  xaToken: string;
};

export function channelGetUserChannelByToken(
  data: channelGetUserChannelByTokenReq
): Promise<channelGetUserChannelByTokenRes> {
  return request.get('/base/channel/getUserChannelByToken', {
    params: data,
  });
}

/**
 * 获取用户总体概况信息
 */

export type userInfoGetUserInfoDetailRes = {
  data: {
    accessId?: string;

    accessKey?: string;

    avatar?: string;

    gender?: string;

    loginTime?: string;

    mobile?: string;

    name?: string;

    registTime?: string;

    userChannelVO: {
      accessId?: string;

      accessKey?: string;

      channelName?: string;
    };

    userStatus?: number;

    userStatusDesc?: string;
  };

  message?: string;

  status?: number;
};

export function userInfoGetUserInfoDetail(): Promise<userInfoGetUserInfoDetailRes> {
  return request.get('/base/userInfo/getUserInfoDetail');
}

/**
 * 更新当前登录用户昵称
 */

export type userInfoUpdateUserNameRes = {
  status: number;

  message: string;
};

export type userInfoUpdateUserNameReq = {
  name: string; // 用户名长度不能超过20字符
};

export function userInfoUpdateUserName(
  data: userInfoUpdateUserNameReq
): Promise<userInfoUpdateUserNameRes> {
  return request.get('/base/userInfo/updateUserName', {
    params: data,
  });
}

/**
 * 更新当前登录用户头像
 */

export type userInfoUpdateUserAvatarRes = {
  status: number;

  message?: string;
};

export function userInfoUpdateUserAvatar(): Promise<userInfoUpdateUserAvatarRes> {
  return request.post('/base/userInfo/updateUserAvatar');
}
